import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    refCode: '',
  },
  mutations: {
    REF_CODE_DATA(state, data) {
        state.refCode = data;
    },
  },
  actions: {
    setRefCode({ commit, state }, data) {
      commit('REF_CODE_DATA', data);
    },
  },
  getters: {
    refCode: (state) => {
      return state.refCode;
    },
  },
});
